var map = {
	"./asl.svg": 930,
	"./banking_circle.svg": 931,
	"./currency_cloud.svg": 932,
	"./dragonpay.svg": 933,
	"./gb_prime.svg": 934,
	"./ocbc.svg": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;